module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "Dedication"
    }
  }, [_c('p', {
    staticClass: "ded"
  }, [_c('b', [_c('i', [_vm._v("Dedication")])])]), _vm._v(" "), _c('p', {
    staticClass: "ded1"
  }, [_c('i', [_vm._v("If nothing else pause and consider the unnecessary death of Second Lieutenant D.A. Addams-Williams, 4th South Wales Borderers, aged 19, leading his troops into battle at Chocolate Hill (Yilchin Burnu) 11 August 1915")]), _vm._v(".")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-13a0f472","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/02_Dedication.vue
// module id = 57
// module chunks = 0